import { addHours } from "date-fns";
import Cookies from "js-cookie";
import React, { createContext, useEffect, useState } from "react";
import config from "../config";
import { api } from "../services/api";

type AuthContextProps = {
  initialized: boolean;
  isLoading: boolean;
  signIn: (email: string, password: string) => Promise<boolean>;
  isAuthenticated: () => boolean;
  signOut: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextProps>(
  {} as AuthContextProps
);

type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [initialized, setInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [applicationId, setApplicationId] = useState<string>("");
  // const [serviceChannelId, setServiceChannelId] = useState<string>("");
  // const [originChannelId, setOriginChannelId] = useState<string>("");

  useEffect(() => {
    setInitialized(true);
  }, []);

  const isAuthenticated = () => {
    try {
      const token = Cookies.get(config.token_key);
      return !!token;
    } catch (error) {
      return false;
    }
  };

  const signIn = async (email: string, password: string) => {
    return new Promise<boolean>(async (resolve, reject) => {
      setIsLoading(true);
      try {
        const res = await api.post("/users-patients/signin", {
          email,
          senha: password,
        });
        const expiryDate = addHours(new Date(), 1);

        Cookies.set(config.token_key, res.data.data.token, {
          expires: expiryDate,
        });
        setIsLoading(false);
        resolve(true);
      } catch (error: any) {
        setIsLoading(false);
        reject(error);
      }
    });
  };
  const signOut = async () => {
    return new Promise<void>((resolve, reject) => {
      setIsLoading(true);
      setInitialized(false);

      Cookies.remove(config.token_key);
      setIsLoading(false);
      window.location.reload();
      resolve();
    });
  };

  return (
    <AuthContext.Provider
      value={{
        initialized,
        isLoading,
        signIn,
        signOut,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
